import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import { ModalStyleFeedback } from "../../../../common/components/ModalStyle";
import {
  AllowToGoCompleteIcon,
  AllowToGoPendingIcon,
  BedReleaseCompleteIcon,
  BedReleasePendingIcon,
  BillingCompleteIcon,
  BillingPendingIcon,
  DischargedCompleteIcon,
  DischargedPendingIcon,
  DischargeInitiateCompleteIcon,
  DischargeInitiatePendingIcon,
  DischargeSummaryFinalizeCompleteIcon,
  DischargeSummaryFinalizePendingIcon,
  MedicineReceivedCompleteIcon,
  MedicineReceivedPendingIcon,
  NursingClearanceCompleteIcon,
  NursingClearancePendingIcon,
  PharmacyClearanceCompleteIcon,
  PharmacyClearancePendingIcon,
} from "../../../../assets/DischargeStatusIcons";
import { getDischargeStatusData } from "../../../services/cliinicalChartServices/DischargeStatusServices";
import { format } from "date-fns";

const DischargeStatusModal = (props) => {
  const {
    openDischargeStatusModal,
    setOpenDischargeStatusModal,
    displayInfo,
    setOpenBackdrop,
  } = props;

  const [dischargeStatusData, setDischargeStatusData] = useState(null);

  const returnDate = (date) => {
    if (!date) return "-----";
    return date?.split("-")?.reverse()?.join("-");
  };

  const returnTime = (time) => {
    if (!time) return "-----";

    const [hour, minute] = time.split(":"); // seconds will be ignored automatically

    const h = parseInt(hour, 10);
    if (isNaN(h)) return "-----";

    const ampm = h >= 12 ? "PM" : "AM";
    const finalHour = h % 12 || 12;

    return `${finalHour}:${minute} ${ampm}`;
  };

  const connecterCss = (fromStage, toStage, direction) => {
    if (!fromStage && !toStage) {
      return "bg-red-600";
    } else if (!!fromStage && !toStage) {
      return `${direction === "right" ? "bg-gradient-to-r" : "bg-gradient-to-l"} from-green-600 to-red-600`;
    } else if (!fromStage && !!toStage) {
      return `${direction === "right" ? "bg-gradient-to-r" : "bg-gradient-to-l"} from-red-600 to-green-600`;
    } else if (!!fromStage && !!toStage) {
      return "bg-green-600";
    }
  };

  useEffect(() => {
    if (displayInfo !== null) {
      setOpenBackdrop(true);
      getDischargeStatusData(displayInfo?.AdmissionId)
        .then((response) => {
          console.log("dischargeStatusData", response?.data?.result);
          setDischargeStatusData(response?.data?.result);
          setOpenBackdrop(false);
        })
        .catch(() => {
          setOpenBackdrop(false);
        });
    }
  }, []);
  return (
    <>
      <Modal open={openDischargeStatusModal}>
        <Box
          sx={ModalStyleFeedback}
          className="w-[90%] xl:w-[80%] 2xl:w-[75%] max-h-[80%] space-y-2"
        >
          <div className="flex justify-between">
            <label className="font-semibold">Discharge Status</label>
            <button
              type="button"
              onClick={() => {
                setOpenDischargeStatusModal(false);
                setDischargeStatusData(null);
              }}
            >
              <CancelPresentationIconButton />
            </button>
          </div>
          <div className="grid grid-cols-2 xl:grid-cols-5 gap-1 bg-[#F1F1F1] p-2 rounded text-sm my-2">
            <div className="flex items-centers xl:col-span-2">
              <label className="font-semibold w-24">Patient Name</label>
              <label>&nbsp;:&nbsp;{displayInfo?.["Patient Name"]}</label>
            </div>
            <div className="flex items-centers">
              <label className="font-semibold w-12">MR No</label>
              <label>&nbsp;:&nbsp;{displayInfo?.MRNo}</label>
            </div>
            <div className="flex items-centers">
              <label className="font-semibold w-24 xl:w-12">Bed No</label>
              <label>&nbsp;:&nbsp;{displayInfo?.["Bed No"]}</label>
            </div>
            <div className="flex items-centers">
              <label className="font-semibold w-12 xl:w-7">Age</label>
              <label>&nbsp;:&nbsp;{displayInfo?.AgeYear}</label>
            </div>
          </div>
          <div className="grid grid-cols-5 gap-y-10 items-center px-10 py-3 h-max">
            <div
              className={`${!dischargeStatusData?.DischargeInitiateDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.DischargeInitiateDate ? (
                  <DischargeInitiatePendingIcon />
                ) : (
                  <DischargeInitiateCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">Discharge Initiate</div>
                <hr
                  className={`${!dischargeStatusData?.DischargeInitiateDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.DischargeInitiateDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.DischargeInitiateTime)}
                  </label>
                </div>
              </div>
            </div>
            <div
              className={`${connecterCss(dischargeStatusData?.DischargeInitiateDate, dischargeStatusData?.NusrsingClearanceDate, "right")} flex items-center h-[3px]`}
            />
            <div
              className={`${!dischargeStatusData?.NusrsingClearanceDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.NusrsingClearanceDate ? (
                  <NursingClearancePendingIcon />
                ) : (
                  <NursingClearanceCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">Nursing Clearance</div>
                <hr
                  className={`${!dischargeStatusData?.NusrsingClearanceDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.NusrsingClearanceDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.NusrsingClearanceTime)}
                  </label>
                </div>
              </div>
            </div>
            <div
              className={`${connecterCss(dischargeStatusData?.NusrsingClearanceDate, dischargeStatusData?.MedReceiveDate, "right")} flex items-center h-[3px]`}
            />
            <div
              className={`${!dischargeStatusData?.MedReceiveDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.MedReceiveDate ? (
                  <MedicineReceivedPendingIcon />
                ) : (
                  <MedicineReceivedCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">Medicine Received</div>
                <hr
                  className={`${!dischargeStatusData?.MedReceiveDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.MedReceiveDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.MedReceiveTime)}
                  </label>
                </div>
              </div>
            </div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div className="w-full flex justify-center">
              <div
                className={`${connecterCss(dischargeStatusData?.MedReceiveDate, dischargeStatusData?.PharmacyClearanceDate, "right")} items-center transform rotate-90 w-20 h-[3px]`}
              />
            </div>
            <div
              className={`${!dischargeStatusData?.DiscDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.DiscDate ? (
                  <DischargedPendingIcon />
                ) : (
                  <DischargedCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">Discharged</div>
                <hr
                  className={`${!dischargeStatusData?.DiscDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.DiscDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.DiscTime)}
                  </label>
                </div>
              </div>
            </div>
            <div
              className={`${connecterCss(dischargeStatusData?.BillingUpdDate, dischargeStatusData?.DiscDate, "left")} flex items-center h-[3px]`}
            />
            <div
              className={`${!dischargeStatusData?.BillingUpdDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.BillingUpdDate ? (
                  <BillingPendingIcon />
                ) : (
                  <BillingCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">Billing</div>
                <hr
                  className={`${!dischargeStatusData?.BillingUpdDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.BillingUpdDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.BillingUpdTime)}
                  </label>
                </div>
              </div>
            </div>
            <div
              className={`${connecterCss(dischargeStatusData?.PharmacyClearanceDate, dischargeStatusData?.BillingUpdDate, "left")} flex items-center h-[3px]`}
            />
            <div
              className={`${!dischargeStatusData?.PharmacyClearanceDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.PharmacyClearanceDate ? (
                  <PharmacyClearancePendingIcon />
                ) : (
                  <PharmacyClearanceCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">Pharmacy Clearance</div>
                <hr
                  className={`${!dischargeStatusData?.PharmacyClearanceDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.PharmacyClearanceDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.PharmacyClearanceTime)}
                  </label>
                </div>
              </div>
            </div>
            <div className="w-full flex justify-center">
              <div
                className={`${connecterCss(dischargeStatusData?.DiscDate, dischargeStatusData?.ClinicalDate, "right")} items-center transform rotate-90 w-20 h-[3px]`}
              />
            </div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div
              className={`${!dischargeStatusData?.ClinicalDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.ClinicalDate ? (
                  <DischargeSummaryFinalizePendingIcon />
                ) : (
                  <DischargeSummaryFinalizeCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">
                  Discharge Summary Finalize
                </div>
                <hr
                  className={`${!dischargeStatusData?.ClinicalDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.ClinicalDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.ClinicalTime)}
                  </label>
                </div>
              </div>
            </div>
            <div
              className={`${connecterCss(dischargeStatusData?.ClinicalDate, dischargeStatusData?.AllowDate, "right")} flex items-center h-[3px]`}
            />
            <div
              className={`${!dischargeStatusData?.AllowDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.AllowDate ? (
                  <AllowToGoPendingIcon />
                ) : (
                  <AllowToGoCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">Allow To Go</div>
                <hr
                  className={`${!dischargeStatusData?.AllowDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.AllowDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.AllowTime)}
                  </label>
                </div>
              </div>
            </div>
            <div
              className={`${connecterCss(dischargeStatusData?.AllowDate, dischargeStatusData?.BedReleaseDate, "right")} flex items-center h-[3px]`}
            />
            <div
              className={`${!dischargeStatusData?.BedReleaseDate ? "bg-red-200 border-red-600 text-[#B91C1C]" : "bg-green-200 border-green-600 text-[#15803D]"} flex space-x-2 items-center border-[3px] p-2 rounded-xl`}
            >
              <div className="flex items-center">
                {!dischargeStatusData?.BedReleaseDate ? (
                  <BedReleasePendingIcon />
                ) : (
                  <BedReleaseCompleteIcon />
                )}
              </div>
              <div className="w-full">
                <div className="font-semibold text-sm">Bed Release</div>
                <hr
                  className={`${!dischargeStatusData?.BedReleaseDate ? "border-[#B91C1C]" : "border-[#15803D]"} border-t-[1px] my-0.5`}
                />
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Date</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnDate(dischargeStatusData?.BedReleaseDate)}
                  </label>
                </div>
                <div className="font-semibold text-xs flex items-center">
                  <label className="w-7">Time</label>
                  <label>
                    &nbsp;:&nbsp;
                    {returnTime(dischargeStatusData?.BedReleaseTime)}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default DischargeStatusModal;
